/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineLangsAvailableLanguages200,
  GetApiV1ClassroomdisciplineLangsAvailableLanguages401,
  GetApiV1ClassroomdisciplineLangsAvailableLanguagesQueryResponse,
} from "../../types/classPlanningLangController/GetApiV1ClassroomdisciplineLangsAvailableLanguages.ts";
import { availableLanguageViewModelSchema } from "../availableLanguageViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineLangsAvailableLanguages200Schema =
  z.array(
    z.lazy(() => availableLanguageViewModelSchema),
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineLangsAvailableLanguages200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineLangsAvailableLanguages401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineLangsAvailableLanguages401>;

export const getApiV1ClassroomdisciplineLangsAvailableLanguagesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineLangsAvailableLanguages200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineLangsAvailableLanguagesQueryResponse>;
